import React from "react";
import { IoChatbubbleEllipses } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { setNavigateToChannel } from "../../../../store/common/chatSlice";

const ChatUnreadMsgNotificationIcon = () => {
  const dispatch = useDispatch();
  const { hasUnreadMsgs } = useSelector((state) => state.chats);

  return (
    <div
      className="relative mr-2 inline-block"
      onClick={() => dispatch(setNavigateToChannel(false))}
    >
      {hasUnreadMsgs ? (
        <div className="absolute bg-[#fab700] rounded-full w-[12px] h-[12px] text-[8px] text-white flex justify-center items-center top-[-8px]"></div>
      ) : (
        ""
      )}
      <IoChatbubbleEllipses
        size={20}
        color="#6b7280"
        className="menu-item-text"
      />
    </div>
  );
};

export default ChatUnreadMsgNotificationIcon;
